import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TranscriptReplayPage } from '@apps/web/features/transcript_replay';

export const Route = createFileRoute('/_app/admin/agent/virtualization')({
    head: () => ({
        meta: [{ title: 'Transcript replay | Internal Admin Agent' }],
    }),
    validateSearch: z.object({
        run: z.string().optional(),
    }),
    component: VirtualizationRoute,
});

function VirtualizationRoute() {
    const { run } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <TranscriptReplayPage
            runId={run ?? null}
            onRunIdSubmit={(nextRun) =>
                navigate({ search: nextRun ? { run: nextRun } : {} })
            }
        />
    );
}
